import React from "react";
import { random, range } from "lodash";

export const printMoney = (money: number) => {
  try {
    return money ? (
      <span>
        {new Intl.NumberFormat("en-US", { maximumFractionDigits: 2 }).format(
          money
        )}{" "}
        <span>UGX</span>
      </span>
    ) : (
      <span>
        {money} {money >= 0 && <span>UGX</span>}
      </span>
    );
  } catch (e) {
    return "";
  }
};

export const printsMoney = (money: number) => {
  try {
    return money ? (
      <span>
        {new Intl.NumberFormat("en-US", { maximumFractionDigits: 2 }).format(
          money
        )}{" "}
        <span>UGX</span>
      </span>
    ) : (
      ""
    );
  } catch (e) {
    return "";
  }
};

export const printNumber = (number: number) => {
  try {
    return number ? new Intl.NumberFormat().format(number) : "";
  } catch (e) {
    return "";
  }
};

export const printDecimal = (number: number) => {
  try {
    return number
      ? new Intl.NumberFormat("en-US", { maximumFractionDigits: 2 }).format(
          number
        )
      : "";
  } catch (e) {
    return "";
  }
};

export const printInteger = (number: number) => {
  try {
    return number
      ? new Intl.NumberFormat("en-US", { maximumFractionDigits: 0 }).format(
          number
        )
      : "";
  } catch (e) {
    return "";
  }
};

export const randomInt = (min = 0, max = 10): number => {
  return random(min, max);
};

export const intRange = (min = 0, max = 10): number[] => {
  return range(min, max);
};

class Numbers {
  public static format_En_UK(value: number) {
      return new Intl.NumberFormat('en-UK').format(value)
  }

  public static unFormat_En_UK_toNumber(formattedValue:string){
      const search = ',';
      const replaceWith = '';
      const result = formattedValue.split(search).join(replaceWith);

      return Number(result);
  }

}

export default Numbers